export default "__VITE_ASSET__oMLIaF5n__"